import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const initialState = {
    constructSelection: 'all',
};

export const dashboardSlice = createSlice({
    name: 'dashboard',
    initialState: initialState as any,
    // The `reducers` field lets us define reducers and generate associated actions
    reducers: {
        setconstructSelection: (state, action: PayloadAction<string>) => {
            state.constructSelection = action.payload;
        },
    }
});

export const { setconstructSelection } = dashboardSlice.actions;

export default dashboardSlice.reducer;

export const selectConstruct = (state: any) => state.dashboard.constructSelection;
